import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HashSvg from './icon-hash.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HashSvg {...validProps} />;
}
SvgComponent.iconName = 'hash';

/**
 * @deprecated This is a legacy icon
 */
export const HashIcon = svgIconWrapper(SvgComponent);
